module.exports = __webpack_public_path__ + "img/xiaomi12timage1mobile.fd50c609.png";